import moment from "moment";

// Display formatting shared by the Pay Inputs screens.

export const API_DATE = "YYYY-MM-DD";

export const formatQty = (value) =>
  Number.isFinite(Number(value)) ? Number(value).toFixed(2) : "–";

export const formatMoney = (value) =>
  Number.isFinite(Number(value))
    ? `₹${Number(value).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "–";

// Quantities from the API can carry more precision than 2 decimals (e.g.
// 0.125 hrs): shown with at least 2 and up to 4 decimals, "–" when missing.
export const formatExactQty = (value) =>
  value === null || value === undefined || value === "" || !Number.isFinite(Number(value))
    ? "–"
    : Number(value).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
        useGrouping: false,
      });

// `value` is an API date (YYYY-MM-DD); anything else is shown as-is.
export const formatDate = (value) => {
  const parsed = moment(value, API_DATE, true);
  return parsed.isValid() ? parsed.format("DD MMM YYYY") : value || "–";
};
